import { useEffect } from 'react';
import { useTheme } from '../../context/ThemeContext';

const FontLoader = () => {
    const { theme } = useTheme();

    useEffect(() => {
        if (!theme) return;

        // 1. Identificar todas as fontes usadas no tema atual
        const keys = Object.keys(theme).filter(k => k.endsWith('Font'));
        const fontsToLoad = new Set();

        keys.forEach(key => {
            const fontName = theme[key];
            if (fontName && fontName !== 'inherit') {
                // Limpa a string (remove aspas e fallbacks ex: '"Inter", sans-serif' -> 'Inter')
                const cleanName = fontName.split(',')[0].replace(/['"]/g, '').trim();
                fontsToLoad.add(cleanName);
            }
        });

        // 2. Adicionar fontes padrão se não estiverem na lista (Segurança)
        fontsToLoad.add('Inter');
        fontsToLoad.add('Playfair Display');
        fontsToLoad.add('Montserrat');
        fontsToLoad.add('Caveat');

        // 3. Construir URL do Google Fonts
        if (fontsToLoad.size > 0) {
            const families = Array.from(fontsToLoad).map(font => `${font.replace(/ /g, '+')}:wght@400;700`).join('&');
            const linkId = 'dynamic-google-fonts';
            
            let link = document.getElementById(linkId);
            if (!link) {
                link = document.createElement('link');
                link.id = linkId;
                link.rel = 'stylesheet';
                document.head.appendChild(link);
            }
            
            // Só atualiza se o URL mudar para evitar reloads desnecessários
            const newHref = `https://fonts.googleapis.com/css2?family=${families}&display=swap`;
            if (link.href !== newHref) {
                link.href = newHref;
            }
        }

    }, [theme]);

    return null; // Este componente não renderiza nada visualmente
};

export default FontLoader;